import request from '@/api/request'

/**
 * 分页获取通知列表（管理端）
 * @param {Object} params - 查询参数
 * @param {string} [params.type] - 消息类型
 * @param {number} [params.priority] - 优先级
 * @param {number} [params.publishStatus] - 发布状态
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页大小
 */
export function getNotificationList(params) {
  return request.get('/notify/messages', { params })
}

/**
 * 获取通知详情（管理端）
 * @param {number} id - 通知ID
 */
export function getNotificationDetail(id) {
  return request.get(`/notify/messages/${id}`)
}

/**
 * 创建通知
 * @param {Object} data - 创建通知命令
 */
export function createNotification(data) {
  return request.post('/notify/messages', data)
}

/**
 * 更新通知（仅限草稿状态）
 * @param {number} id - 通知ID
 * @param {Object} data - 更新通知命令
 */
export function updateNotification(id, data) {
  return request.put(`/notify/messages/${id}`, data)
}

/**
 * 删除通知（仅限草稿状态）
 * @param {number} id - 通知ID
 */
export function deleteNotification(id) {
  return request.delete(`/notify/messages/${id}`)
}

/**
 * 修改通知发布状态
 * @param {number} id - 通知ID
 * @param {Object} data - 修改发布状态命令
 */
export function updatePublishStatus(id, data) {
  return request.put(`/notify/messages/${id}/publish-status`, data)
}

/**
 * 标记通知已读
 * @param {number} id - 通知ID
 */
export function markNotificationRead(id) {
  return request.put(`/notifications/${id}/read`)
}

/**
 * 标记所有通知已读
 */
export function markAllNotificationsRead() {
  return request.put('/notifications/all/read')
}

/**
 * 获取未读通知数量
 * @returns {Promise<number>} 未读通知数量
 */
export function getUnreadCount() {
  return request.get('/notifications/unread/count')
}

/**
 * 获取通知列表（用户端）
 * @param {Object} params - 查询参数
 * @param {string} [params.type] - 消息类型
 * @param {string} [params.status] - 通知状态 UNREAD/READ/DELETED
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页大小
 */
export function getNotifications(params) {
  return request.get('/notifications', { params })
}

/**
 * 删除通知（用户端）
 * @param {number} id - 通知ID
 */
export function deleteUserNotification(id) {
  return request.delete(`/notifications/${id}`)
}
